module.exports = __webpack_public_path__ + "img/lby.d089645e.svg";